<template>
  <ABTable class="px-6" ref="goodsTable" :isLoading="isLoading" @onFetchRemoteData="fetchRemoteData()"
      :table-data="rows" :page-title="returnNoteNumber ? `Return Note R${returnNoteNumber}` : 'Return Note Details'" :router-url="routerUrl" :filters="filters"
      :columns="columns" :select-options="{enabled: false}"
      :total-count="totalCount" :hasDetailsPage="false" :no-actions="true"
      :showSelectionColumn="false" :external-query="false">
      <template v-slot:createButton>
        <button class="btn-primary btn-save" @click="printContent" style="background-color: blue;">Print</button>
      </template>
  </ABTable>

  <div id="printable-content" style="display: none;">
    <div class="w-100 to-deliver">
      <table class="print-table" style="border-collapse: collapse; text-align: center; width:100%;">
        <thead>
          <tr>
            <th colspan="100%">
              <div class="print-header d-flex justify-content-between">
                <div class="col-md-6">
                  <div style="font-weight: bold; font-size: 25px;">Despatched to Trelleborg</div>
                  <div style="font-weight: bold; font-size: 20px;">Return Delivery Note</div>
                  <div style="font-size: 16px;">
                    Return Note R{{ returnNoteNumber }}<br/>
                    Date: {{ currentDate }}
                  </div>
                </div>
                <div class="col-md-6 text-right">
                  <div class="address-logo">
                    <div><img src="../assets/inspectra-logo-dark.png" alt="Inspectra Logo" style="max-width: 100px"/></div>
                    <div class="address">
                      MRA49B, Marsa Industrial Estate,<br/>Marsa.<br/>VAT 17434222
                    </div>
                  </div>
                </div>
              </div>
            </th>
          </tr>
          <tr>
            <th v-for="(column, i) in columns" :key="i" style="border:1px solid black; padding:6px;">{{ column.label }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="isLoading"><td :colspan="columns.length" class="text-center">Loading...</td></tr>
          <tr v-else-if="!rows.length"><td :colspan="columns.length" class="text-center">No Data Available</td></tr>
          <tr v-for="(row, i) in rows" :key="i" v-else>
            <td v-for="(col, j) in columns" :key="j" style="border:1px solid black; padding:6px;" :data-field="col.field">
              <template v-if="col.field === 'passed' || col.field === 'failed'">/</template>
              <template v-else>{{ row[col.field] != null ? row[col.field] : '' }}</template>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="100%" style="padding-top: 50px;">
              <div style="display: flex;">
                <div style="flex:1; margin:0 10px; border-top:1px solid black; text-align:center;">Delivered on time By</div>
                <div style="flex:1; margin:0 10px; border-top:1px solid black; text-align:center;">Checked by</div>
                <div style="flex:1; margin:0 10px; border-top:1px solid black; text-align:center;">Received on time By</div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import ABTable from '../components/ABTable.vue';
import { useDeliveryNotePrintedStore } from '@/stores/deliveryNotePrinted.js';
import { useToast } from 'vue-toast-notification';
const $toast = useToast();

export default {
  name: 'ReturnNoteDetails',
  components: { ABTable },
  data() {
    return {
      isLoading: false,
      rows: [],
      totalCount: 0,
      returnNoteNumber: '',
      currentDate: new Date().toLocaleDateString('en-GB'),
      pageTitle: 'Return Note Details',
      routerUrl: '',
      filters: {},
      columns: [
        { label: 'Bag No',          field: 'bagNumber',      sortable: false },
        { label: 'MO Number',       field: 'moNumber',       sortable: false },
        { label: 'Chit Number',     field: 'chitNumber',     sortable: false },
        { label: 'Part Number',     field: 'partNumber',     sortable: false },
        { label: 'Supplier',        field: 'supplier',       sortable: false },
        { label: 'Inspection Type', field: 'inspectionType', sortable: false },
        { label: 'Issued',          field: 'quantityIssued', sortable: false },
        { label: 'Passed',          field: 'passed',         sortable: false },
        { label: 'Failed',          field: 'failed',         sortable: false },
      ],
    };
  },
  async mounted() {
    await this.fetchRemoteData();
  },
  methods: {
    async fetchRemoteData() {
      const id = this.$route.params.id;
      if (!id) return;
      this.isLoading = true;
      const store = useDeliveryNotePrintedStore();
      try {
        const noteResponse = await store.fetchDeliveryNotePrintedById(id);
        if (noteResponse) {
          this.returnNoteNumber = noteResponse.returnNoteNumber || noteResponse.id;
        }
        const bagsResponse = await store.fetchReturnNotesBags(id);
        if (bagsResponse && bagsResponse.ok) {
          const bags = await bagsResponse.json();
          this.rows = bags.sort((a, b) => a.bagNumber < b.bagNumber ? -1 : 1);
          this.totalCount = this.rows.length;
        } else {
          $toast.error('Failed to load bags for this return note');
        }
      } catch (e) {
        $toast.error('Error loading return note details');
      }
      this.isLoading = false;
    },
    printContent() {
      const printContents = document.getElementById('printable-content').innerHTML;
      const originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      document.body.pageSize = 'A4';
      document.body.style.fontSize = '12px';
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload();
    },
  },
};
</script>

<style scoped>
#printable-content { display: none; }
@media print { @page { size: landscape; margin: 10mm; } }
.button-container { display: flex; justify-content: space-between; align-items: center; gap: 0.5rem; }
.delivery-number { font-size: 1.2rem; font-weight: bold; }
.right-container { display: flex; gap: 0.5rem; align-items: center; }
</style>
